import GenericError from "./genericError";

class NotFoundError extends GenericError {
    constructor(message) {
        super(message, 404);
        this.name = "NotFoundError";
    }
}

export default NotFoundError;